import { useMemo, useCallback } from 'react'
import { AnalyticsHook } from '../types'

/**
 * useNoOpAnalytics
 *
 * Hook for no-op analytics (on-premises deployments).
 * All analytics calls are silently ignored (no external services called).
 */
export default function useNoOpAnalytics(): AnalyticsHook {
  const logEvent = useCallback((): void => {
    // No-op: analytics disabled for on-prem
  }, [])

  const setCurrentScreen = useCallback((): void => {
    // No-op: analytics disabled for on-prem
  }, [])

  const setUserId = useCallback((): void => {
    // No-op: analytics disabled for on-prem
  }, [])

  const setUserProperties = useCallback((): void => {
    // No-op: analytics disabled for on-prem
  }, [])

  return useMemo(
    () => ({
      logEvent,
      setCurrentScreen,
      setUserId,
      setUserProperties,
    }),
    [logEvent, setCurrentScreen, setUserId, setUserProperties]
  )
}
